import ProgressNumNFT from "../components/ProgressNumNFT";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import Loading from "../components/Loading";
import { useAddress } from "../contexts/Context";
import { useEffect, useState } from "react";
import { getMyNFT } from "../services/api";
import ItemNFT from "../components/ItemNFT";
import { useHistory } from "react-router-dom";
import ConnectWallet from "../components/ConnectWallet";
import Bubble from "../components/coral/Bubble";
import CoralRightType1 from "../components/coral/CoralRightType1";
import CoralRightType2 from "../components/coral/CoralRightType2";
import CustomButton from "../components/CustomButton";

export default function MyNFT() {
  const history = useHistory();
  const [itemList, setItemList] = useState([]);
  const [ethAddress] = useAddress();
  const [loading, setLoading] = useState(false);
  // const [num, setNum] = useState(0)
  useEffect(() => {
    if (ethAddress) {
      getNFTList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ethAddress]);

  // useEffect(() => {
  //   setInterval(() => {
  //     setNum(old => old + 1)
  //   },1000)
  // },[])

  async function getNFTList() {
    setLoading(true);
    getMyNFT(ethAddress).then((result) => {
      if (result.success) {
        // console.log(result.message)
        setItemList(result.message.items);
      }
      setLoading(false);
    });
  }

  return (
    <div className="pageContainer myNFTContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <Loading loading={loading} />
      <CoralRightType2 />
      <CoralRightType1 />
      <Bubble top={"200px"} />

      <div className="header">
        <div className="title">MY NFTs</div>
        <ProgressNumNFT numNFT={itemList.length} />

        <div className="withdrawBtn">
          <CustomButton
            text={"WITHDRAW"}
            textColor={"black"}
            fn={() => history.push("/withdraw")}
            type={"small"}
            transparent={false}
          />
        </div>
      </div>

      <div className="middle">
        <div className="myNFTList">
          {itemList.map((item, index) => {
            if (item) {
              return (
                <ItemNFT
                  key={index}
                  id={item.nft.name}
                  image={item.nft.imageUrl}
                  rarityPercentage={item.nft.point}
                  rarityClass={item.nft.rare}
                  fn={() => history.push("/detail/" + item.nft.tokenId)}
                />
              );
            } else {
              return (
                <ItemNFT
                  key={index}
                  id={null}
                  image={null}
                  rarityPercentage={null}
                  rarityClass={null}
                />
              );
            }
          })}
          {itemList.length === 0 ? (
            <div className="collectionEmpty">Your collection is empty</div>
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
